import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';

@Injectable({ providedIn: 'root' })
export class FinancingModalityService {
    constructor(private dataService: DataService) {}

    public get() {
        return this.dataService.get<Result<any>>('financingmodality');
    }
}
